<template>
  <div @click="closeMultiSelect">
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="modal-title font-weight-bold">Assign Class</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- ERROR ALERT -->
        <div style="position: relative; top: -30px; margin-bottom: -8px">
          <AuthAlertCard
            v-if="show_alert"
            :alert_type="alert_type"
            :alert_msg="alert_msg"
          ></AuthAlertCard>
        </div>

        <form action @submit.prevent="confirmAssignment" autocomplete="off">
          <!-- TEACHER NAME -->
          <div class="modal-body-row row">
            <div
              class="user-info-section col-12 d-flex justify-content-start align-items-center nowrap"
            >
              <!-- AVATAR -->
              <div class="avatar avatar_lg brand_inverse_light_bg mr-3">
                <img
                  v-lazy="image"
                  :alt="name"
                  class="avatar-img"
                  v-if="image"
                />
                <div
                  class="avatar-text white-text font-weight-bold font-20"
                  :class="setAvatarBg"
                  v-else
                >
                  {{ getInitial }}
                </div>
              </div>

              <!-- USER INFO -->
              <div class="user-info" v-if="name">
                <div class="name font-weight-bold brand_navy text-capitalize">
                  {{ name }}
                </div>
                <div class="email border_grey_dark">{{ email }}</div>
              </div>

              <div class="default-user-info" v-else>
                <div
                  class="name rounded-10 skeleton-loader overflow-hidden"
                ></div>
                <div
                  class="email rounded-10 skeleton-loader overflow-hidden"
                ></div>
              </div>
            </div>
          </div>

          <!-- TEACHER CLASS -->
          <div class="ignore" style="margin-bottom: 35px">
            <Multiselect
              label_text="Assign to class"
              :label_compact="true"
              :options="class_options"
              :trigger_close="close_select"
              :multiple="false"
              placeholder="Assign to a class"
              @selectionDone="updateCLassList($event)"
            ></Multiselect>
          </div>

          <!-- TEACHER SUBJECT -->
          <div class="ignore">
            <Multiselect
              label_text="Assign Subject(s)"
              :label_compact="true"
              :options="subject_options"
              :trigger_close="close_select"
              :multiple="true"
              placeholder="Assign subject(s)"
              @selectionDone="updateSubjectList($event)"
            ></Multiselect>
          </div>

          <!-- SEND INVITATION-->
          <div class="modal-body-row row mt-5 mb-1 button-row">
            <div class="col-12 d-flex flex-center">
              <button
                type="submit"
                class="btn btn-md transparent-bg z-depth-0 brand_navy font-weight-bold"
                @click="$emit('closeTriggered')"
              >
                Cancel
              </button>

              <button
                type="submit"
                class="btn btn-md btn-accent"
                :disabled="is_disabled"
                ref="confirmBtn"
              >
                Confirm
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { setInitial } from "@/scripts/utilities";
import { setProfileBg } from "@/scripts/profile-colors";
import Modal from "@/components/globalComps/Modal";
import Multiselect from "@/components/globalComps/Multiselect";
import { setTimeout } from "timers";

export default {
  name: "AssignClassModal",

  components: {
    Modal,
    Multiselect,
    AuthAlertCard: () =>
      import(
        /* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard.vue"
      ),
  },

  props: {
    teacher_id: Number,
  },

  computed: {
    setAvatarBg() {
      return setProfileBg(this.name);
    },

    getInitial() {
      return setInitial(this.name);
    },

    is_disabled() {
      if (this.form.class_id !== "" && this.form.subjects.length > 0)
        return false;
      else return true;
    },
  },

  data() {
    return {
      form: {
        teacher_id: "",
        class_id: "",
        subjects: [],
      },
      value: [],
      name: "",
      email: "",
      image: "",
      class_options: [],
      subject_options: [],

      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null,
      close_select: true,
    };
  },

  mounted() {
    this.fetchTeacherInfo();
    this.fetchClasses();
    this.fetchSubjects();
  },

  methods: {
    ...mapActions([
      "getTeacherProfile",
      "getSchoolClasses",
      "getSubjectList",
      "assignClassAndSubject",
    ]),

    closeMultiSelect($event) {
      if ($event.target.classList.contains("ignore")) return false;
      else this.close_select = !this.close_select;
    },

    fetchTeacherInfo() {
      this.form.teacher_id = this.teacher_id;
      this.getTeacherProfile(this.teacher_id)
        .then((response) => {
          this.name = `${response.data.firstname} ${response.data.lastname}`;
          this.email = response.data.email;
          this.image = response.data.image;
        })
        .catch((err) => console.log(err));
    },

    fetchClasses() {
      this.getSchoolClasses()
        .then((response) => {
          response.data.map((year) => {
            year.classes.map((arm) => {
              let class_arm = {};
              class_arm.id = Number(arm.id);
              class_arm.name = arm.class_name;
              class_arm.selected = false;
              this.class_options.push(class_arm);
            });
          });
        })
        .catch((err) => console.log(err));
    },

    fetchSubjects() {
      this.getSubjectList()
        .then((response) => {
          if (response.data.length > 0) {
            response.data.map((subject) => {
              let subject_data = {};

              subject_data.id = Number(subject.subject_id);
              subject_data.name = subject.name;
              subject_data.selected = false;

              this.subject_options.push(subject_data);
            });
          } else {
            this.subject_options.push({});
          }
        })
        .catch((err) => console.log(err));
    },

    updateCLassList($event) {
      if ($event.selection.length)
        this.form.class_id = Number($event.selection[0].id);
      else this.form.class_id = "";
    },

    updateSubjectList($event) {
      this.form.subjects = [];
      $event.selection.map((subject) => {
        this.form.subjects.push(Number(subject.id));
      });
    },

    confirmAssignment() {
      this.$refs.confirmBtn.disabled = true;
      this.$refs.confirmBtn.innerHTML =
        '<div class="icon-dotted-roller font-16 mr-2 animate"></div>Please wait..';

      this.assignClassAndSubject(this.form)
        .then((response) => {
          if (response.code === 200) {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.confirmBtn.disabled = true;
              this.$refs.confirmBtn.innerHTML =
                '<div class="icon-accept font-17 mr-2"></div>Successful';
            }, 1000);

            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "success";
              this.alert_msg = "Teacher assigned to class successfully!";
            }, 2500);

            setTimeout(() => {
              this.$emit("refreshPage");
              this.$emit("closeTriggered");
            }, 4500);
          }

          //   HANDLE NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg = response.message;

              this.$refs.confirmBtn.innerText = "Confirm";
              this.$refs.confirmBtn.disabled = false;
            }, 1000);

            setTimeout(() => {
              this.show_alert = false;
            }, 5000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  @include breakpoint_max(sm) {
    font-size: 12px !important;
  }
}
.user-info-section {
  @include breakpoint_max(sm) {
    margin-bottom: 20px;
  }
  .avatar {
    .avatar-text {
      font-size: 14px !important;
    }
  }
  .user-info {
    transition: all 0.4s ease-in-out;
    .name {
      font-size: 19px;
      line-height: 25px;
      margin-bottom: 4px;

      @include breakpoint_max(sm) {
        line-height: 18px;
        margin-bottom: 1px;
        font-size: 14px;
      }
    }
    .email {
      font-size: 14px;
      line-height: 19px;

      @include breakpoint_max(sm) {
        font-size: 12.5px;
      }
    }
  }

  .default-user-info {
    .name {
      width: 200px;
      height: 25px;
      margin-bottom: 5px;
    }
    .email {
      width: 250px;
      height: 18px;
    }
  }
}

.button-row {
  @include breakpoint_max(sm) {
    margin-top: 5px !important;
    margin-bottom: -10px !important;
  }
}
</style>
